import { cn } from '@/utils'

interface CoverageChipProps {
  label: string
  title: string
  count: number
  dotClassName: string
  isActive: boolean
  onClick: () => void
}

// A chip, not a legend entry, so it says it can be pressed. A pressed chip fills in, so a map
// with months dimmed always shows why.
export const CoverageChip = ({
  label,
  title,
  count,
  dotClassName,
  isActive,
  onClick,
}: CoverageChipProps) => (
  <button
    type="button"
    aria-pressed={isActive}
    title={title}
    onClick={onClick}
    className={cn(
      'inline-flex h-7 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 text-xs transition-colors',
      isActive
        ? 'border-neutral-900 bg-neutral-900 text-white'
        : 'bg-white hover:border-neutral-300 hover:bg-neutral-50',
    )}
  >
    <span className={cn('size-2 shrink-0 rounded-full', dotClassName)} />
    <span
      className={cn(
        'font-medium tabular-nums',
        isActive ? 'text-white' : 'text-foreground',
      )}
    >
      {count.toLocaleString()}
    </span>
    <span className={isActive ? 'text-white/70' : 'text-ink-subtle'}>
      {label}
    </span>
  </button>
)
